/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'newspaper-variant-multiple': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M4 7v12h15v2H4c-2 0-2-2-2-2V7h2m2-4v12c0 2 2 2 2 2h13c2 0 2-2 2-2V3H6m7 9H9V6h4v6m7 0h-5v-2h5v2m0-4h-5V6h5v2z"/>'
  }
})
